/**********************************************************************************************************************/
/* FILE: display-fullmap/hafas_webapp_subscriptions_gui.js                                                            */
/**********************************************************************************************************************/
/* Subscriptions GUI */
HafasWebapp.prototype.subscriptions.GUI = function(_me) {
  // GUI-Events -------------------------------------------------------------------------------------------------------
  // Cookie Hint
  Hafas.ps.sub('/gui/showCookieHint', Hafas.bind(_me.Controller.GUI.common.showCookieHint,_me));
  Hafas.ps.sub('/gui/hideCookieHint', Hafas.bind(_me.Controller.GUI.common.hideCookieHint,_me));

  Hafas.ps.sub('/GUI/common/toggle', Hafas.bind(_me.Controller.GUI.common.toggle,_me));
  // Neue Toggle-Funktion mit Aria-Attributen
  Hafas.ps.sub('/GUI/common/atomToggleContainer', Hafas.bind(_me.Controller.GUI.common.atomToggleContainer,_me));
  Hafas.ps.sub('/GUI/common/atomToggleChecked', Hafas.bind(_me.Controller.GUI.common.atomToggleChecked,_me));
  Hafas.ps.sub('/GUI/common/atomForwardClick', Hafas.bind(_me.Controller.GUI.common.atomForwardClick,_me));
  Hafas.ps.sub('/GUI/common/atomForwardKeyToClick', Hafas.bind(_me.Controller.GUI.common.atomForwardKeyToClick,_me));
  Hafas.ps.sub('/GUI/common/remove', Hafas.bind(_me.Controller.GUI.common.remove,_me));
  Hafas.ps.sub('/GUI/common/getLayoutClass', Hafas.bind(_me.Controller.GUI.common.getLayoutClass,_me));
  Hafas.ps.sub('/GUI/common/back', Hafas.bind(_me.Controller.GUI.goBack,_me));
  Hafas.ps.sub('/GUI/common/toggleMobileMenu', Hafas.bind(_me.Controller.GUI.common.toggleMobileMenu, _me));
  Hafas.ps.sub('/GUI/common/hideMobileMenu', Hafas.bind(_me.Controller.GUI.common.hideMobileMenu, _me));
  Hafas.ps.sub('/GUI/common/showMobileMenu', Hafas.bind(_me.Controller.GUI.common.showMobileMenu, _me));
  Hafas.ps.sub('/GUI/common/toggleLanguage', Hafas.bind(_me.Controller.GUI.common.toggleLanguagesMenu, _me));
  // Accessibility: Messages
  Hafas.ps.sub('/GUI/common/messages/toggleExcerptMessage', Hafas.bind(_me.Controller.GUI.common.messages.toggleExcerptMessage,_me));

  Hafas.ps.sub('/GUI/common/setApplicationHeader', Hafas.bind(_me.Controller.GUI.common.setApplicationHeader,_me));

  /* Overlay Test Subscription */
  Hafas.ps.sub('/GUI/overlay/test', Hafas.bind(_me.Controller.GUI.overlay.test,_me));
  Hafas.ps.sub('/GUI/overlay/push', Hafas.bind(_me.Controller.GUI.overlay.push,_me));


  // Calendar export
  Hafas.ps.sub('/GUI/calendarExport/showOptions', Hafas.bind(_me.Controller.GUI.calendarExport.showExportOptions,_me));
  Hafas.ps.sub('/GUI/calendarExport/closeOptions', Hafas.bind(_me.Controller.GUI.calendarExport.closeExportOptions,_me));

  // Share Trip
  Hafas.ps.sub('/GUI/shareTrip', Hafas.bind(_me.Controller.ShareTrip.showOverlay,_me));
  Hafas.ps.sub('/GUI/shareTrip/switchChannel', Hafas.bind(_me.Controller.ShareTrip.switchChannel,_me));
  Hafas.ps.sub('/GUI/shareTrip/sendMail', Hafas.bind(_me.Controller.ShareTrip.sendMail,_me));
  Hafas.ps.sub('/GUI/shareTrip/sendSMS', Hafas.bind(_me.Controller.ShareTrip.sendSMS,_me));
  Hafas.ps.sub('/GUI/shareTrip/sendLink', Hafas.bind(_me.Controller.ShareTrip.sendLink,_me));
  Hafas.ps.sub('/GUI/shareTrip/createShortLink', Hafas.bind(_me.Controller.ShareTrip.createShortLink,_me));
  Hafas.ps.sub('/GUI/shareTrip/closeOverlay', Hafas.bind(_me.Controller.ShareTrip.closeOverlay,_me));
  Hafas.ps.sub('/GUI/shareTrip/copyLink', Hafas.bind(_me.Controller.ShareTrip.copyLink,_me));
  Hafas.ps.sub('/GUI/shareTrip/shareWithAPI', Hafas.bind(_me.Controller.ShareTrip.shareWithAPI,_me));

  // Small ALerts
  Hafas.ps.sub('/GUI/smallAlert/show', Hafas.bind(_me.Controller.GUI.smallAlert.show, _me));

};
